module.exports = __webpack_public_path__ + "img/imgPdtInfo1.521c8a43.png";